import {
  HTTP_UPDATESPECIAL_FETCHING,
  HTTP_UPDATESPECIAL_SUCCESS,
  HTTP_UPDATESPECIAL_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_UPDATESPECIAL_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_UPDATESPECIAL_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_UPDATESPECIAL_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
